import { ProductTypeEnum, defaultProductDownloadValues } from '@systemeio/digital-store-shared'
import { ProductDownloadItemEditType } from 'modules/stores/store/content/product/types/product-interface'

export const defaultValues: ProductDownloadItemEditType = {
  ...defaultProductDownloadValues,
  draft: false,
  productType: ProductTypeEnum.download,
  checkoutPage: {
    fields: [],
    title: '',
    buttonTitle: '',
    description: '',
    cover: null,
    offerId: null,
    digitalProductId: undefined,
  },
  thankYouPage: {
    title: '',
    text: '',
  },
}
